// Page_Partner_Facturation.jsx
import React, { useEffect, useState } from "react";
import { Loader } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { BillingsAPI } from "../../../../api/billingsAPI";
import { useAuth } from "../../../../hooks";
import { ListBilling } from "../../../../components/BillingsCmp/ListBillings/ListBilling";
import "./Page_Partner_Facturation.scss";

const billingController = new BillingsAPI();

export function Page_Partner_Facturation() {
  const { t } = useTranslation("institution");
  const { accessToken, user } = useAuth();
  const [billings, setBillings] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        // Obtenemos facturas del user actual
        const response = await billingController.getBillingsByUser(
          accessToken,
          user.user._id,
        );
        setBillings(response.data); // { code, message, data: [ ... ] }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [accessToken, user.user._id]);

  // Verificamos si es partner
  const isPartner = user.user.role.toLowerCase() === "partner";

  if (loading) return <Loader active inline="centered" />;
  if (!billings) return null;

  return (
    <div className="page-partner-facturation">
      <h2>{t("partner.billing.title")}</h2>
      {/* isPartner = true => muestra columna Proveedor, comisión, etc. */}
      <ListBilling billings={billings} isPartner={isPartner} />
    </div>
  );
}
